import {cn} from 'platform/shared-tw';

import {PartSvg, type PartMode} from '../shared/PartSvg';
import {partFill, partStroke, type DiagramVariant} from '../shared/partVariants';

interface SteeringWheelProps {
  readonly mode?: PartMode;
  readonly variant?: DiagramVariant;
  readonly onClick?: () => void;
}

export function SteeringWheel(props: SteeringWheelProps) {
  return (
    <PartSvg
      mode={props.mode}
      onClick={props.onClick}
      label="Steering Wheel"
      width={73}
      height={98}
      viewBox="0 0 73 98"
      position={{top: 305, left: 472}}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M55 1C65.649 1.00046 72 14.4007 72 28V70C72 83.5993 65.649 96.9995 55 97C40.2331 97.0006 36.0409 79.7203 35.1855 65.999L35 66H1V32H35.1855C36.041 18.2789 40.2334 0.999368 55 1ZM64 59.9678C60.0014 66.945 55.0036 65.9519 45.0107 65.9512V65.9854C45.0017 73.5532 47.1227 84.6558 55.5293 88L56 87.9883C58.9949 86.9882 63.9999 83 64 67.0771V59.9678ZM55.7158 9.9043C47.1536 13.1573 45.0017 24.3685 45.0107 31.9922V32.0479C55.0036 32.0471 60.0014 31.055 64 38.0322V30.9121C64 14.9888 58.9949 11 56 10L55.7158 9.9043Z"
        fill="currentColor"
        className={cn(partFill({variant: props.variant}))}
      ></path>
      <path
        d="M19.1119 18.9272C16.1787 22.9496 17.1564 28.9832 17.1564 32H21.0673V31.9992C21.0674 27.9774 21.0675 25.9662 23.0228 22.9496L34.7556 7.86567C34.7556 7.86567 35.7333 6.35732 33.7778 4.8489C31.8224 3.34049 30.3559 4.16666 29.8669 4.84891C29.8669 4.84891 22.4563 14.3408 19.1119 18.9272Z"
        fill="currentColor"
        className={cn(partFill({variant: props.variant}))}
      ></path>
      <path
        d="M17.1564 32C17.1564 28.9832 16.1787 22.9496 19.1119 18.9272C22.4563 14.3408 29.8669 4.84891 29.8669 4.84891C30.3559 4.16666 31.8224 3.34049 33.7778 4.8489C35.7333 6.35732 34.7556 7.86567 34.7556 7.86567L23.0228 22.9496C21.0674 25.9664 21.0674 27.9776 21.0673 32"
        stroke="currentColor"
        strokeWidth="2"
        className={partStroke({variant: props.variant})}
      />
      <path
        d="M27 9C28 8 32 9 32 12"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
      />
      <path
        d="M19.1119 79.0728C16.1787 75.0504 17.1564 69.0168 17.1564 66H21.0673V66.0008C21.0674 70.0226 21.0675 72.0338 23.0228 75.0504L34.7556 90.1343C34.7556 90.1343 35.7333 91.6427 33.7778 93.1511C31.8224 94.6595 30.3559 93.8333 29.8669 93.1511C29.8669 93.1511 22.4563 83.6592 19.1119 79.0728Z"
        fill="currentColor"
        className={cn(partFill({variant: props.variant}))}
      ></path>
      <path
        d="M17.1564 66C17.1564 69.0168 16.1787 75.0504 19.1119 79.0728C22.4563 83.6592 29.8669 93.1511 29.8669 93.1511C30.3559 93.8333 31.8224 94.6595 33.7778 93.1511C35.7333 91.6427 34.7556 90.1343 34.7556 90.1343L23.0228 75.0504C21.0674 72.0336 21.0674 70.0224 21.0673 66"
        stroke="currentColor"
        strokeWidth="2"
        className={partStroke({variant: props.variant})}
      />
      <path
        d="M27 89C28 90 32 89 32 86"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
      />
      <path
        d="M35 60V49V38C35 24 37.9634 0.999271 55 1C65.649 1.00046 72 14.4007 72 28V49V70C72 83.5993 65.649 96.9995 55 97C37.9634 97.0007 35 74 35 60Z"
        stroke="currentColor"
        strokeWidth="2"
        className={partStroke({variant: props.variant})}
      />
      <path
        d="M6 30.9885V66.9885"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
      />
      <path
        d="M64 59.9681C60 66.9478 55 65.9507 45 65.9507M35 63.9565C30 61.9623 30 55.9797 30 53.0805V49V44.9194C30 42.0203 30 36.0377 35 34.0435M64 38.0319C60 31.0521 55 32.0492 45 32.0492"
        stroke="currentColor"
        strokeWidth="2"
        className={partStroke({variant: props.variant})}
      />
      <path
        d="M35 66H1L1.00001 49V32H35"
        stroke="currentColor"
        strokeWidth="2"
        className={partStroke({variant: props.variant})}
      />
      <path
        d="M1 66C10.3888 66 18 58.3888 18 49C18 39.6112 10.3888 32 1 32"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
      />
      <path
        d="M64 25C64 21.7987 71 20.7316 72 23.9329"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
      />
      <path
        d="M39 12.9462C41 10.9246 48 11.9354 48 18"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
      />
      <path
        d="M64 73C64 76.2013 71 77.2684 72 74.0671"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
      />
      <path
        d="M39 85.0538C41 87.0754 48 86.0646 48 80"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
      />
      <path
        d="M56 10C58.9949 11 64 14.9885 64 30.9119C64 33.3459 64 35.1567 64 37"
        stroke="currentColor"
        strokeWidth="2"
        className={partStroke({variant: props.variant})}
      />
      <path
        d="M56 87.9885C58.9949 86.9885 64 83 64 67.0767C64 64.6427 64 62.8318 64 60.9885"
        stroke="currentColor"
        strokeWidth="2"
        className={partStroke({variant: props.variant})}
      />
      <path
        d="M61.0107 88.9885C48.002 88.9885 45 74.9865 45.0107 65.9852V48.9943V48.9828V31.9918C45 22.9905 48.002 8.98853 61.0107 8.98853"
        stroke="currentColor"
        strokeWidth="2"
        className={partStroke({variant: props.variant})}
      />
      <ellipse
        cx="61.5"
        cy="48.988"
        rx="5.5"
        ry="13"
        fill="currentColor"
        className={cn(partFill({variant: props.variant}))}
      ></ellipse>
      <ellipse
        cx="61.5"
        cy="48.988"
        rx="5.5"
        ry="13"
        stroke="currentColor"
        strokeWidth="2"
        className={partStroke({variant: props.variant})}
      />
      <ellipse
        cx="64.5"
        cy="48.9885"
        rx="2.5"
        ry="7"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
      />
    </PartSvg>
  );
}
